<template>
    <div class="grid-home" style="height:100%;">
      <div class="title-box">
          工厂车间环境质量及卫生监控周报（{{dateRangeText}}）
      </div>
      <div class="wrapper">
        <div class="one grid-content">
          <span class="pre-title"></span>
          <span class="col-title">监控对象/事件</span>
          <div>
            <el-row style="margin-top:10px;">
              <el-col :span="12">
                <div class="num-div" style="color:#3083FB">{{monitorAlarmSummary.monitoredFactoryCount}}</div>
                <div class="title-div">监控工厂数</div>
              </el-col>
              <el-col :span="12">
                <div class="num-div" style="color:#3083FB">{{monitorAlarmSummary.monitoredSceneCount}}</div>  
                <div class="title-div">监控场景数</div>
              </el-col>
            </el-row>
            <el-row style="margin-top:10px;">
              <el-col :span="12">
                <div class="num-div" style="color:rgba(48, 131, 251, 1)">{{monitorAlarmSummary.monitoredWorkshopCount}}</div>
                <div class="title-div">监控车间数</div>
              </el-col>
              <el-col :span="12">
                <div class="num-div" style="color:rgba(253, 64, 90, 1)">{{monitorAlarmSummary.alarmSceneCount}}</div>
                <div class="title-div">发生报警场景数</div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="two grid-content">
          <span class="pre-title"></span>
          <span class="col-title">一周管控得分</span>
          <div id="controlBar" style="height:160px;width:100%;"></div>
        </div>
        <div class="three grid-content">
          <span class="pre-title"></span>
          <span class="col-title">高频报警场景（TOP20排行）</span>
          <el-table :data="top20TableData" :show-header="false" style="height:430px;width:100%;font-size: 12px;" :cell-style="cellStyle" :row-style="{height:'25px'}">
            <el-table-column prop="sceneName" label="场景名称" :show-overflow-tooltip="true" align="left"/>
            <el-table-column prop="alarmCount" label="报警数" width="35" align="right"/>
          </el-table>
        </div>
        <div class="four grid-content">
          <span class="pre-title"></span>
          <span class="col-title">车间达标率</span>
          <div>
            <!-- 压差达标率 -->
            <el-col :span="12" id="diffLine" style="height:179px;">1</el-col>
            <!-- 臭氧浓度达标率 -->
            <el-col :span="12" id="ozoneLine" style="height:179px;">2</el-col>
            <!-- 空气洁净度达标率 -->
            <el-col :span="12" id="airLine" style="height:179px;">3</el-col>
            <!-- 人员洗消执行率 -->
            <el-col :span="12" id="decontLine" style="height:179px;">4</el-col>
            <!-- 温湿度合格率 -->
            <el-col :span="12" id="humitureLine" style="height:179px;">5</el-col>
            <!-- 禁区禁行执行率 -->
            <el-col :span="12" id="prohibitLine" style="height:179px;">6</el-col>
          </div>
        </div>
        <div class="five grid-content">
          <span class="pre-title"></span>
          <span class="col-title">报警类型占比</span>
          <div id="alarmPie" style="height:240px;margin-top:-20px;"></div>
        </div>
        <div class="six grid-content">
          <span class="pre-title"></span>
          <span class="col-title">报警数变化</span>
          <div id="alarmBar" style="height:260px;"></div>
        </div>
        <div class="seven grid-content">
          <span class="pre-title"></span>
          <span class="col-title">报告摘要</span>
          <span class="sub-title">周报仅为提示摘要，需要进一步了解详情，请查询相关明细报表。</span>
          <!-- <div v-for="item in abstractData">
            <div class="abstractItem">{{ item.text }}</div>
          </div> -->
          <div>
            <div class="abstractItem">本周，{{formatDateLocal(abstractScore.statsStartDate)}}至{{formatDateLocal(abstractScore.statsEndDate)}}，
              工厂车间日管控综合得分，在{{abstractScore.integratedControlScoreMin}}分至{{abstractScore.integratedControlScoreMax}}分之间波动，
              周平均分{{abstractScore.integratedControlScoreAvg}}；其中环境质量得分在{{abstractScore.envControlScoreMin}}至{{abstractScore.envControlScoreMax}}之间波动，
              周平均分{{abstractScore.envControlScoreAvg}}；卫生管控得分在{{abstractScore.hygieneControlScoreMin}}至{{abstractScore.hygieneControlScoreMax}}之间波动，
              周平均分{{abstractScore.hygieneControlScoreAvg}}.评分覆盖的范围是{{abstractScore.factCnt}}个工厂、{{abstractScore.workCnt}}个车间、{{abstractScore.scenCnt}}个场景。</div>
            <div class="abstractItem">压差达标率，在{{abstractStats.diffPressureCrMin}}%至{{abstractStats.diffPressureMax}}%之间波动，平均达标率为{{abstractStats.diffPressureCrAvg}}%；空气洁净度达标率，在{{abstractStats.airCleanlinessCrMin}}%至{{abstractStats.airCleanlinessCrMax}}%之间波动，平均达标率为{{abstractStats.airCleanlinessCrAvg}}%；温湿度合格率在{{abstractStats.tempHumidityCrMin}}%至{{abstractStats.tempHumidityCrMax}}%之间波动，平均达标率为{{abstractStats.tempHumidityCrAvg}}%。臭氧浓度合格率，在{{abstractStats.ozoneConcCrMin}}%至{{abstractStats.ozoneConcCrMax}}%之间波动，平均达标率为{{abstractStats.ozoneConcCrAvg}}%。人员洗消执行率，在{{abstractStats.personnelWashCrMin}}%至{{abstractStats.personnelWashCrMax}}%之间波动，平均达标率为{{abstractStats.personnelWashCrAvg}}%；禁区禁行执行率在{{abstractStats.zoneRestrictCrMin}}%至{{abstractStats.zoneRestrictCrMax}}%之间波动，平均达标率为{{abstractStats.zoneRestrictCrAvg}}%。</div>
            <div class="abstractItem">本周日发生的报警事件，一共{{alarmComputation.alarmEventCount}}起；
              其中压差报警占比{{alarmComputation.pressureDiffAlarmPercentage}}%，
              空气洁净度报警占比{{alarmComputation.airCleanlinessAlarmPercentage}}%，
              温湿度报警占比{{alarmComputation.temperatureHumidityAlarmPercentage}}%，
              洗消执行报警数占比{{alarmComputation.disinfectionComplianceAlarmPercentage}}%，
              禁区闯入报警数是{{alarmComputation.restrictedZoneIntrusionPercentage}}%，
              臭氧浓度报警数占比{{alarmComputation.ozoneConcentrationAlarmPercentage}}%。</div>
            <div class="abstractItem">
              <div>报警事件涉及{{alarmComputation.alarmFactoryCount}}个工厂，{{alarmComputation.alarmWorkshopCount}}个车间，{{alarmComputation.alarmSceneCount}}个场景。</div>
              <div v-if="alarmComputation. alarmSceneTop1">其中报警数TOP5的场景，按从多到少排序，分别是
                {{ alarmComputation. alarmSceneTop1}}
                <span v-if="alarmComputation. alarmSceneTop2">、{{ alarmComputation. alarmSceneTop2}}</span>
                <span v-if="alarmComputation. alarmSceneTop3">、{{ alarmComputation. alarmSceneTop3}}</span>
                <span v-if="alarmComputation. alarmSceneTop4">、{{ alarmComputation. alarmSceneTop4}}</span>
                <span v-if="alarmComputation. alarmSceneTop5">、{{ alarmComputation. alarmSceneTop5}}</span>。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
  import * as echarts from 'echarts';
  import { formatDateTimeCustom } from '@/utils/base';
  export default {
    data() {
      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 6);
      return {
        dateRangeText: `${formatDateTimeCustom(startDate, 'YYYY-MM-DD')} 至 ${formatDateTimeCustom(endDate, 'YYYY-MM-DD')}`,
        controlBar:null,
        diffLine:null,
        ozoneLine:null,
        airLine:null,
        decontLine:null,
        humitureLine:null,
        prohibitLine:null,
        alarmPie:null,
        alarmBar:null,
        resizeHandler: null,
        abstractStats:{
          statsStartDate: "",
          statsEndDate: "",
          diffPressureCrMin: 0,
          diffPressureCrAvg: 0,
          diffPressureMax: 0,
          ozoneConcCrMin: 0,
          ozoneConcCrAvg: 0,
          ozoneConcCrMax: 0,
          personnelWashCrMin: 0,
          personnelWashCrAvg: 0,
          personnelWashCrMax: 0,
          zoneRestrictCrMin: 0,
          zoneRestrictCrAvg: 0,
          zoneRestrictCrMax: 0,
          tempHumidityCrMin: 0,
          tempHumidityCrAvg: 0,
          tempHumidityCrMax: 0,
          airCleanlinessCrMin: 0,
          airCleanlinessCrAvg: 0,
          airCleanlinessCrMax: 0
        },
        abstractScore:{
          statsStartDate: "",
          statsEndDate: "",
          envControlScoreMin: 0,
          envControlScoreAvg: 0,
          envControlScoreMax: 0,
          hygieneControlScoreMin: 0,
          hygieneControlScoreAvg: 0,
          hygieneControlScoreMax: 0,
          integratedControlScoreMin: 0,
          integratedControlScoreAvg: 0,
          integratedControlScoreMax: 0,
          factCnt:0,
          workCnt: 2,
          scenCnt: 13
        },
        monitorAlarmSummary:{
          monitoredFactoryCount: 0,
          monitoredWorkshopCount: 0,
          monitoredSceneCount: 0,
          alarmSceneCount: 0
        },
        monitoringAlarmSceneDetai:[],
        top20TableData:[],
        alarmComputation:{
          alarmEventCount: 0,
          alarmFactoryCount: 0,
          alarmWorkshopCount: 0,
          alarmSceneCount: 0,
          pressureDiffAlarmPercentage: 0,
          airCleanlinessAlarmPercentage: 0,
          temperatureHumidityAlarmPercentage: 0,
          ozoneConcentrationAlarmPercentage: 0,
          restrictedZoneIntrusionPercentage: 0,
          disinfectionComplianceAlarmPercentage: 0,
          alarmSceneTop1: "",
          alarmSceneTop2: "",
          alarmSceneTop3: "",
          alarmSceneTop4: "",
          alarmSceneTop5: ""
        }
      }
    },
    activated() {
      if(this.$store.state.login.token){
        this.resizeHandler();
        window.addEventListener('resize', this.resizeHandler);
      }
    },
    deactivated() {
      if(this.$store.state.login.token){
        this.disposeHandler();
      }
      window.removeEventListener('resize', this.resizeHandler);
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.resizeHandler);
    },
    mounted() {
      this.geQualityWeek();
      this.getComplianceRate();
      this.initAbstract();
      this.resizeHandler = () => {
        if(this.$store.state.login.token){
          if(this.controlBar){
            this.controlBar.resize();
          }
          else{
            this.geQualityWeek();
          }
          if(this.alarmPie){
            this.alarmPie.resize();
            this.alarmBar.resize();
          }
          else{
            this.initAbstract();
          }
          if(this.diffLine){
            this.diffLine.resize();
            this.ozoneLine.resize();
            this.airLine.resize();
            this.decontLine.resize();
            this.humitureLine.resize();
            this.prohibitLine.resize();
          }
          else{
            this.getComplianceRate();
          }
        }
      };
    },
    methods: {
      cellStyle({row, column, rowIndex, columnIndex}){
        if(columnIndex === 1){
          return {
            color: 'rgba(253, 64, 90, 1)',
            padding: '8px 0'
          };
        }
        return {
          padding: '8px 0'
        };
      },
      formatDateLocal(dateString){
        let date = new Date(dateString);
        const formattedDate = `${date.getFullYear()}年${(date.getMonth() + 1).toString().padStart(2, '0')}月${date.getDate().toString().padStart(2, '0')}日`;
        return formattedDate
      },
      // 一周管控得分柱状-折线图
      initControlBar(date,data1,data2,data3){
        let chartDom = document.getElementById('controlBar');
        if(chartDom){
          this.controlBar = echarts.init(chartDom);
          let option;
          let barWidth = '15%';
          if(date.length <= 3){
            barWidth = 20;
          }else if(date.length <= 5){
            barWidth = 25;
          }
          option = {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                crossStyle: {
                  color: '#999'
                }
              }
            },
            legend: {
              top: 20,
              right:0,
              width:100,
              itemGap: 12,
              itemWidth: 12,
              itemHeight: 8,
              textStyle: {
                fontSize: 8
              }
            },
            grid: {
              left: 25,
              top: 20,
              right: 80,
              bottom: 30
            },
            xAxis: [
              {
                type: 'category',
                data: date,
                axisPointer: {
                  type: 'shadow'
                },
                axisLabel:{
                  fontSize:8,
                  color:"#000"
                },
                axisTick: {
                  show: false
                },
                axisLine: {
                  show: false
                }
              }
            ],
            yAxis: [
              {
                type: 'value',
                axisLabel: {
                  fontSize:8,
                  color:"#000"
                }
              }
            ],
            series: [
              {
                name: '环境质量得分',
                type: 'bar',
                itemStyle:{
                  color:"rgba(48, 131, 251, 1)"
                },
                barWidth: barWidth,
                data: data1
              },
              {
                name: '卫生管控得分',
                type: 'bar',
                itemStyle:{
                  color:"rgba(251, 215, 48, 1)"
                },
                barWidth: barWidth,
                data: data2
              },
              {
                name: '综合得分',
                type: 'line',
                itemStyle:{
                  color:"rgba(247, 174, 63, 1)"
                },
                symbol: "diamond",
                symbolSize: '8',
                data: data3
              }
            ]
          };
          option && this.controlBar.setOption(option);
        }
      },
      // 一周管控得分柱状数据查询
      geQualityWeek(){
        this.$store.dispatch('home/getQualityWeekReport').then((result)=>{
          let dateArr = [];
          let valueArr1 = [];
          let valueArr2 = [];
          let valueArr3 = [];
          if(result?.data){
            let data = result?.data;
            for(let i=0;i<data.length;i++){
              dateArr.push(formatDateTimeCustom(data[i].statDate,'MM-DD'));
              valueArr1.push(data[i].envControlScore)
              valueArr2.push(data[i].hygieneControlScore)
              valueArr3.push(data[i].integratedControlScore)
            }
          }
          this.initControlBar(dateArr,valueArr1,valueArr2,valueArr3)
        })
      },
      // 获取车间达标率数据
      getComplianceRate(){
        this.$store.dispatch('home/getComplianceRateWeek').then((result)=>{
          let arr1 = [];
          let arr2 = [];
          let arr3 = [];
          let arr4 = [];
          let arr5 = [];
          let arr6 = [];
          let date = [];
          if(result?.data){
            let data = result.data;
            for(let i=0;i<data.length;i++){
              arr1.push(data[i].diffPressureCr)
              arr2.push(data[i].ozoneConcCr)
              arr3.push(data[i].airCleanlinessCr)
              arr4.push(data[i].personnelWashCr)
              arr5.push(data[i].tempHumidityCr)
              arr6.push(data[i].zoneRestrictCr)

              date.push(formatDateTimeCustom(data[i].statDate,'MM-DD'))
            }
          }
          this.initRateline('diffLine','rgba(75, 190, 255, 1)',arr1,date,"压差达标率");
          this.initRateline('ozoneLine','rgba(247, 174, 63, 1)',arr2,date,"臭氧浓度达标率");
          this.initRateline('airLine','rgba(48, 131, 251, 1)',arr3,date,"空气洁净度达标率");
          this.initRateline('decontLine','rgba(253, 64, 90, 1)',arr4,date,"人员洗消执行率");
          this.initRateline('humitureLine','rgba(1, 236, 146, 1)',arr5,date,"温湿度达标率");
          this.initRateline('prohibitLine','rgba(26, 225, 217, 1)',arr6,date,"禁区禁行执行率");
        })
      },
      // 车间达标率折线图
      initRateline(id, color, data, date, title){
        let chartDom = document.getElementById(id);
        if(chartDom){
          this[id] = echarts.init(chartDom);
          let option = {
            title: {
              text: title,
              textStyle:{
                fontSize:10,
                color:'rgba(102, 102, 102, 1)'
              },
              left: "center"
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                crossStyle: {
                  color: '#999'
                }
              },
              formatter: '{b0}:{c0}%'
            },
            grid: {
              left: 40,
              top: 20,
              right: 10,
              bottom: 30
            },
            xAxis: {
              type: 'category',
              axisLabel:{
                fontSize:8,
                color:"rgba(102, 102, 102, 1)"
              },
              data: date,
            },
            yAxis: {
              type: 'value',
              axisLine: {
                show: true
              },
              axisLabel: {
                formatter: '{value}%',
                fontSize:8,
                color:"rgba(102, 102, 102, 1)"
              },
              min: 'dataMin' // 让 y 轴从数据的最小值开始
            },
            series: [
              {
                data,
                type: 'line',
                itemStyle:{
                  color
                },
              }
            ]
          };
          option && this[id].setOption(option);
        }
      },
      // 报警类型占比饼状图
      initAlarmPie(sData){
        let chartDom = document.getElementById("alarmPie");
        if(chartDom){
          this.alarmPie = echarts.init(chartDom);
          let option = {
            color:['rgba(75, 190, 255, 1)','rgba(48, 131, 251, 1)','rgba(247, 174, 63, 1)','rgba(253, 64, 90, 1)','rgba(26, 225, 217, 1)','rgba(1, 236, 146, 1)'],
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: -6,
              itemGap: 5,
              itemWidth: 10,
              itemHeight: 6,
              textStyle: {
                fontSize: 9,
                color:'rgba(102, 102, 102, 1)'
              }
            },
            series: [
              {
                type: 'pie',
                radius: ['35%', '75%'],
                avoidLabelOverlap: false,
                label: {
                  position: 'inner',
                  formatter: function (params) {
                    return params.data.value+"%";
                  },
                },
                labelLine: {
                  show: false
                },
                data:sData
              }
            ]
          };
          option && this.alarmPie.setOption(option);
        }
      },
      // 报警数变化柱状堆叠图
      initAlarmBar(xBarData,seriesData){
        let chartDom = document.getElementById("alarmBar");
        if(chartDom){
          this.alarmBar = echarts.init(chartDom);
          let barWidth = '15%';
          if(xBarData.length <= 3){
            barWidth = 20;
          }else if(xBarData.length <= 5){
            barWidth = 25;
          }
          seriesData.forEach(item => {
            item.barWidth = barWidth;
          });
          let option = {
            color:['rgba(75, 190, 255, 1)','rgba(48, 131, 251, 1)','rgba(247, 174, 63, 1)','rgba(253, 64, 90, 1)','rgba(26, 225, 217, 1)','rgba(1, 236, 146, 1)'],
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            legend: {
              top: 20,
              right:0,
              width:100,
              itemGap: 12,
              itemWidth: 11,
              itemHeight: 8,
              textStyle: {
                fontSize: 8
              }
            },
            grid: {
              left: 40,
              top: 20,
              right: 100,
              bottom: 30
            },
            xAxis: [
              {
                type: 'category',
                axisTick: {
                  show: false
                },
                axisLine: {
                  show: false
                },
                data: xBarData
              }
            ],
            yAxis: [
              {
                type: 'value'
              }
            ],
            series: seriesData
          };
          option && this.alarmBar.setOption(option);
        }
      },
      // 查询摘要数据
      initAbstract(){
        // 查询周报摘要达标率综合统计
        this.$store.dispatch('home/getCompStatsWeek').then((result)=>{
          if(result?.data){
            this.abstractStats = result.data
          }
        })
        // 查询周报报摘要得分
        this.$store.dispatch('home/getCompScoreWeek').then((result)=>{
          if(result?.data){
            this.abstractScore = result.data
          }
        })
        // 监控周报-获取报警相关数据
        this.$store.dispatch('home/getWeekMonitoringAlarm').then((result)=>{
          if(result?.data){
            this.monitorAlarmSummary = result.data.weeklyMonitoringAlarmSummary
            this.monitoringAlarmSceneDetai = result.data.weeklyMonitoringAlarmSceneDetailListTop20
            this.top20TableData = this.monitoringAlarmSceneDetai.map(item => ({
              sceneName: item.factoryName + '-' + item.workshopName + '-' + item.sceneName,
              alarmCount: item.alarmCount
            }))
            this.alarmComputation = result.data.alarmComputationReport
            let alarmRateList = [{ value: this.alarmComputation.pressureDiffAlarmPercentage, name: '压差报警' },
                  { value: this.alarmComputation.airCleanlinessAlarmPercentage, name: '空气洁净度报警' },
                  { value: this.alarmComputation.ozoneConcentrationAlarmPercentage, name: '臭氧浓度报警' },
                  { value: this.alarmComputation.disinfectionComplianceAlarmPercentage, name: '洗消执行报警' },
                  { value: this.alarmComputation.restrictedZoneIntrusionPercentage, name: '禁区闯入报警' },
                  { value: this.alarmComputation.temperatureHumidityAlarmPercentage, name: '温湿度报警' }];
            
            this.initAlarmPie(alarmRateList)
            let xBarData = result.data.weeklyAlarmChartDataVo.xdata.map(date => {
              if(date && date.includes('-')){
                const parts = date.split('-');
                return `${parts[1]}-${parts[2]}`;
              }
              return date;
            });
            let seriesData = [];
            let barData = result.data.weeklyAlarmChartDataVo.ydata;
            for(let i=0;i<barData.length;i++){
              seriesData.push({
                name: barData.name,
                type: 'bar',
                stack: 'Ad',
                emphasis: {
                  focus: 'series'
                },
                data: barData.data
              })
            }
            this.initAlarmBar(xBarData,seriesData)
            }
          })
      },
      disposeHandler(){
        if(this.controlBar){
          this.controlBar.dispose();
          this.controlBar = null;
        }
        if(this.diffLine){
          this.diffLine.dispose();
          this.diffLine = null;
        }
        if(this.ozoneLine){
          this.ozoneLine.dispose();
          this.ozoneLine = null;
        }
        if(this.airLine){
          this.airLine.dispose();
          this.airLine = null;
        }
        if(this.decontLine){
          this.decontLine.dispose();
          this.decontLine = null;
        }
        if(this.humitureLine){
          this.humitureLine.dispose();
          this.humitureLine = null;
        }
        if(this.prohibitLine){
          this.prohibitLine.dispose();
          this.prohibitLine = null;
        }
        if(this.alarmPie){
          this.alarmPie.dispose();
          this.alarmPie = null;
        }
        if(this.alarmBar){
          this.alarmBar.dispose();
          this.alarmBar = null;
        }
      }
    }
}
</script>
<style lang="scss" scoped>
  .title-box{
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        padding: 27px 0 15px;
        line-height: 16px;
    }
  .grid-home {
    overflow-y: auto;
    .grid-content{
      background: #fff;
      border-radius: 3px;
      padding: 10px;
      .pre-title{
          display: inline-block;
          width: 3px;
          height: 12px;
          background-color: #3083FB;
          border-radius: 1.5px;
          margin-right: 5px;
          margin-bottom: -1.5px;
      }
      .col-title{
        font-size: 14px;
      }
      .sub-title{
        display: inline-block;
        font-size: 12px;
        text-align: right;
        width: calc(100% - 67px);
      }
      .abstractItem{
        padding: 10px;
        border-bottom: 1px solid rgba(237, 240, 245, 1);
        font-size: 12px;
        color:rgba(72, 73, 76, 1);
        text-indent: 24px;
      }
      .num-div{
        font-size: 16px;
        font-weight: bold;
        margin-top: 26px;
        text-align: center;
      }
      .title-div{
        font-size: 12px;
        color:#666666;
        text-align: center;
      }
    }
  } 

.wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
  /*  声明行的高度  */
  grid-template-rows: 190px 270px 290px 300px;
  .one {
    grid-column: 1 / 2;
    grid-row: 1;
  }
  .two { 
    grid-column: 2 / 4;
    grid-row: 1;
  }
  .three {
    grid-column: 4;
    grid-row: 1/3;
  }
  .four {
    grid-column: 1/3;
    grid-row: 2/4;
  }
  .five {
    grid-column: 3;
    grid-row: 2/3;
  }
  .six {
    grid-column: 3/5;
    grid-row: 3;
  }
  .seven {
    grid-column: 1/5;
    grid-row: 4;
  }
  ::v-deep .three {
    .el-table {
      border: none;
      .el-table__body-wrapper {
        border: none;
      }
      .el-table__body {
        border: none;
      }
      .el-table__row {
        background: transparent !important;
        &:hover > td {
          background: transparent !important;
        }
        td {
          border: none;
          // padding: 0 !important;
        }
      }
      .cell {
        padding-left: 0px !important;
        padding-right: 0px !important;
      }
      .el-table__cell {
        border: none;
        // padding: 0 !important;
      }
      .alarm-count-cell {
        color: rgba(253, 64, 90, 1) !important;
      }
      &::before {
        display: none;
      }
      &::after {
        display: none;
      }
    }
  }
}

</style>